(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      let loader = document.createElement('div');
      loader.classList.add('loader');
      document.body.appendChild(loader);
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      checkLocale(this.elements.input.value).then(result => { 
        console.log('language updated'); 
        if (form) form.submit(); 
      });
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationFormHeader extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      let loader = document.createElement('div');
      loader.classList.add('loader');
      document.body.appendChild(loader);
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      checkLocale(this.elements.input.value).then(result => { 
        console.log('language updated');
        if (form) form.submit(); 
      });
    }

  }

  customElements.define('localization-form-header', LocalizationFormHeader);

  class LocalizationFormHeaderMobile extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      let loader = document.createElement('div');
      loader.classList.add('loader');
      document.body.appendChild(loader);
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      checkLocale(this.elements.input.value).then(result => { 
        console.log('language updated'); 
        if (form) form.submit(); 
      });
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form-header-mobile', LocalizationFormHeaderMobile);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-lookbook-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .then(() =>{
            this.intializeSlider();
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    intializeSlider(){
      const recommendListContainer = $('.recommend-slider') || null;
      const WINDOW_WIDTH = $(window).width();
      if(recommendListContainer != null && recommendListContainer.length > 0 && WINDOW_WIDTH > 989){
        let slideToScrollPos = 4;
        let sectionTotalSLide = Number($(recommendListContainer).attr('data-total-slide'));
        if(sectionTotalSLide > 4){
          $(recommendListContainer).on('init reInit afterChange',function(event,slick,currentSlide) {
            if(!currentSlide) currentSlide = 0;
            let currentIndex = currentSlide + slideToScrollPos;
            $(recommendListContainer).closest('section').find('.pagingInfo').text(Math.ceil(currentIndex/slideToScrollPos) + ' / ' + Math.ceil(sectionTotalSLide/slideToScrollPos));
          });
          $(recommendListContainer).slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            arrows: true
          });
        }
      }else{
        if(document.querySelector('.lookbook-product-recommendations .recommend-slider')){
          let halfCardWidth = Math.ceil(document.querySelector('.lookbook-product-recommendations .recommend-slider .grid__item').offsetWidth/2); 
          document.querySelector('.lookbook-product-recommendations .recommend-slider').scrollLeft = halfCardWidth;
        }
      }
    }
    
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.intializeSlider();
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    intializeSlider(){
      const recommendListContainer = $('.recommend-slider') || null;
      const WINDOW_WIDTH = $(window).width();
      if(recommendListContainer != null && recommendListContainer.length > 0 && WINDOW_WIDTH > 989){
        $(recommendListContainer).slick({
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 5,
          dots: false,
          arrows: false,
          responsive: [
            {
              breakpoint: 1601,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              }
            }
          ]
        });
      }
    }
    
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
